import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { GET_FABRIC_DATA } from '@/graphql/queries';
import addDomainToPath from 'commons/addDomainToPath';
import JBImage from 'components/essentials/JBImage';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import SanitizedHtml from '../SanitizedHtml';
const MaterialSwatch = t0 => {
  const $ = _c(16);
  const {
    fabricValueName,
    fabricDescription,
    fabricImage,
    fabricValueId
  } = t0;
  let t1;
  if ($[0] !== fabricValueId) {
    t1 = {
      variables: {
        fabricValueId
      }
    };
    $[0] = fabricValueId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    loading,
    error
  } = useSuspenseQuery(GET_FABRIC_DATA, t1);
  const fabricData = data?.getFabrics;
  if (loading || error || !fabricData && !fabricValueName) {
    return null;
  }
  const t2 = `/option_images/swatches/165x165-${fabricData?.[0]?.option_image || fabricImage}`;
  let t3;
  if ($[2] !== t2) {
    t3 = addDomainToPath(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex items-center min-w-[200px] max-[765px]:w-full max-[765px]:items-center max-[765px]:justify-center"><div className="w-full max-[765px]:w-[unset]"><JBImage width={165} height={165} src={t3} /></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = fabricData?.[0]?.option_value || fabricValueName;
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="text-[1.2rem] leading-[2.375rem] tracking-[-.02em] mt-0 mx-0 mb-[1.1rem] font-normal text-gray">{t5}</div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = fabricData?.[0]?.option_description || fabricDescription;
  let t8;
  if ($[8] !== t7) {
    t8 = <SanitizedHtml html={t7} />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <div className="flex flex-1 flex-col items-start ml-6 text-gray">{t6}{t8}</div>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t4 || $[14] !== t9) {
    t10 = <div className="flex flex-row items-start pb-6 max-[765px]:flex-col max-[765px]:mt-6">{t4}{t9}</div>;
    $[13] = t4;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
MaterialSwatch.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.string,
    getFabrics: PropTypes.func
  }),
  fabricValueName: PropTypes.string,
  fabricDescription: PropTypes.string,
  fabricImage: PropTypes.string
};
export default MaterialSwatch;